module.exports = __webpack_public_path__ + "static/media/portfolio-6.502b25ba.jpg";